import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterRequiredFormula, formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "defaultValue",
                "readonlyFormula",
                "displayEmpty",
                "emptyValue",
                "requiredFormula",
                "dataLinkage",
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.Dropdown').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.Dropdown').toString() }),
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        // 只读条件
        readonlyCondition: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "readonlyCondition",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        dataLinkage: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/data-linkage2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 默认值
        defaultValue: {
            options: {
                transaction({ attr, attrs, displayFields }) {
                    // const type = 0;
                    if (attr.dataItem && attr.dataItem.type === 1) {
                        delete attr.options.regexps;
                    }
                    // ;
                },
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
        // 选项
        options: {
            attrType: "dropdownOption",
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/biz-option-data-model2.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        // 是否显示空选项
        displayEmpty: {
            options: {
                hideField: (value) => {
                    if (!value) {
                        return ["emptyValue"];
                    }
                    else {
                        return [];
                    }
                },
            },
        },
        // 空选项显示值
        emptyValue: {
            options: {
                regexps: {
                    maxLength: {
                        len: 200,
                        message: i18n.t('dataitem.ValidityErrTips', { num: 200 }).toString(),
                    },
                },
            },
        },
    },
};
